export const UTM_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
];

// Campaign attribution is untrusted input. Store only the agreed fields.
export function normalizeAttribution(input) {
  const result = {};
  for (const field of UTM_FIELDS) {
    const value = input?.[field];
    if (typeof value !== 'string') continue;
    const cleaned = Array.from(value)
      .filter((character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127)
      .join('').trim().slice(0, 256);
    if (cleaned) result[field] = cleaned;
  }
  return result;
}

export function attributionFromSearch(search) {
  return normalizeAttribution(Object.fromEntries(new URLSearchParams(search)));
}

export function trialEventData(companyId, company) {
  const startedAt = company.trialStart.startedAt;
  return {
    // Keep the existing GTM trigger; do not push a second conversion event.
    event: 'Opret bruger profil',
    label: 'Udfyldt formular og oprettet bruger profil',
    company_id: companyId,
    event_id: company.trialStart.eventId,
    trial_started_at: startedAt.toDate().toISOString(),
    ...Object.fromEntries(
      UTM_FIELDS.map((field) => [field, company.attribution?.[field] || null]),
    ),
  };
}

export function attributionCsv(companyId, company) {
  const fields = ['company_id', 'company_name', ...UTM_FIELDS, 'trial_event_id'];
  const values = [companyId, company.name, ...UTM_FIELDS.map((field) => company.attribution?.[field]), company.trialStart?.eventId];
  const cell = (value) => {
    let text = String(value ?? '');
    // Prevent spreadsheet formulas in user-supplied campaign/company values.
    if (/^[\s]*[=+@-]/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
  };
  return `\uFEFF${fields.map(cell).join(';')}\r\n${values.map(cell).join(';')}\r\n`;
}
